import { useMemo, useState } from "react";

import { useMultiSiteContext } from "../use-site-context";
import { useUserContext } from "../use-auth-context";
import { WpMediaPost } from "@components/file-display-list/types";

const API_URL = "wp-json/wp/v2/media/";

export const useSiteMedia = () => {
  const [media, setMedia] = useState<WpMediaPost[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  const { user } = useUserContext();
  const { getApiUrl } = useMultiSiteContext();
  const apiUrl = useMemo(() => getApiUrl(API_URL), [getApiUrl]);

  const fetchMedia = async (id: string) => {
    setLoading(true);
    setError(null);
    try {
      const response = await fetch(`${apiUrl}${id}`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${user?.authToken ?? ""}`,
        },
      });
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const data = await response.json();
      setMedia(data);
      setLoading(false);
      return data;
    } catch (err) {
      setError(`Error fetching media: ${(err as Error).message}`);
      setLoading(false);
      return null;
    }
  };

  return {
    media,
    loading,
    error,
    fetchMedia,
  };
};
